export enum Source {
  DELTA = 'delta',
  EXTERNAL = 'external',
  INTERNAL = 'partfiniti',
}

export enum PartType {
  BOM = 'bom',
  PART = 'part',
}

export enum ExternalPartStatusType {
  ABANDONED = 'Abandoned',
  ACTIVE = 'Active',
  DEACTIVATED = 'Deactivated',
  DEPRECATED = 'Deprecated',
}
